<template><div></div></template>

<script>
export default {
  async mounted() {
    let key = this.$route.params.id;
    let r = await this.$client.get("/api/company/getIdFromKey?key=" + key);

    if (r.data.isSuccess) {
      location.href = "/#/customer/" + r.data.value.id;
    }
  },
};
</script>

<style></style>
